/* eslint-disable */
import { ParamsData } from '../app';

const rgpd = () => {
    let consentMode;

    const scrollThresholds = [30, 60, 90];
    let thresholdsReached = [];

    const checkScrollThresholds = () => {
        const scrolledPercentage = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;

        scrollThresholds.forEach(threshold => {
            if (scrolledPercentage >= threshold && !thresholdsReached.includes(threshold)) {
                thresholdsReached.push(threshold);
                pa.sendEvent('page.scroll', {
                    'scroll_rate': threshold
                });
            }
        });
    };

    checkScrollThresholds();

    window.addEventListener('scroll', () => {
        checkScrollThresholds();
    });

    window.addEventListener('page:load', () => {
        thresholdsReached = []; // Réinitialiser pour la nouvelle page chargée
    });


    const analyticButtons = document.querySelectorAll('[data-click]');

    analyticButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            const clickValue = this.getAttribute('data-click');
            const contentFormat = this.getAttribute('data-content-format');
            const eventPlacement = this.getAttribute('data-event-placement');
            const eventDetailPlacement = this.getAttribute('data-event-detail-placement');
            const eventType = this.getAttribute('data-event-type');
            const avContent = this.getAttribute('data-av-content');
            const selectedProfileInput = document.querySelector('input[name="newsletter_je_suis"]:checked');
            const profile = selectedProfileInput ? selectedProfileInput.value : null;
          
            const eventObject = {
                 click: clickValue,
                ...(contentFormat && { 'content_format': contentFormat }),
                ...(eventPlacement && { 'event_placement': eventPlacement }),
                ...(eventDetailPlacement && { 'event_detail_placement': eventDetailPlacement }),
                ...(avContent && { 'av_content': avContent }),
                ...(profile && { 'profile': profile }),
            };

            let eventId;
            if (eventType === 'newsletter.subscription') {
                eventId = eventType;
            } else {
                eventId = `click.${eventType}`;
            }
           
            pa.sendEvent(eventId, eventObject);
        });
    });

    /**
     * Didomi / piano 
     * gestion opt-out
     * 
     */

    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push(function (Didomi) {

        // Check the consent status for the Piano Analytics vendor
        const userStatus = Didomi.getCurrentUserStatus();
        const defaultstatus = userStatus.vendors.hasOwnProperty("pianohybr-R3VKC2r4") && Didomi.getCurrentUserStatus().vendors["pianohybr-R3VKC2r4"].enabled;

        if (defaultstatus) {
            // If the consent status is true, activate the opt-in visitor mode
            pa.consent.setByPurpose("AM", "opt-in");
        } else {
            // Else, if the visitor mode is not “opt-out”, then activate the essential mode
            if (pa.consent.getByPurpose().AM.mode != "opt-out") {
                pa.consent.setByPurpose("AM", "essential");
            }
        }

        // Opt-out 3eme niveau consentement (au clic sur refuser) :
        const optout = document.getElementById('optout');
        if (optout) {
            optout.onchange = () => {
                const transaction = Didomi.openCurrentUserStatusTransaction();

                if (!optout.checked) {
                    transaction.disablePurpose("audiencem-hJxaeGrR");
                    transaction.disableVendor("pianohybr-R3VKC2r4");
                    transaction.commit();
                    pa.consent.setByPurpose("AM", "opt-out");
                }
            }

            optout.checked = pa.consent.getByPurpose().AM.mode == "opt-in" ? true : false;
        }

        consentMode = pa.consent.getByPurpose().AM.mode;

        // page display
        const datas = window.datalayer;

        function add(key, exempt) {
            let obj = {};

            if (datas[key] && consentMode != "") {
                obj[key] = datas[key];
            }

           /* if (!exempt && consentMode === "essential") {
                obj = {};
            }*/

            return obj
        }

        pa.setProperties({
            ...add("page", true),
            ...add("page_chapter1", true),
            ...add("error_type", false),
            ...add("content_category", false),
            ...add("tags", false),
            ...add("filters", false),
        }, {
            'persistent': true
        });

        pa.sendEvent('page.display', {});

        console.log("consent is: ", consentMode);
    });

};

export default rgpd;